/**
 *
 *
 */

/**
 *
 */
export function bufferToBase64URL(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer)
    let binary = ""
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i])
    }
    return btoa(binary).replace(/\+/g, "-").replace(/\/*                       */
}

/**
 *
 */
export function base64URLToBuffer(base64url: string): ArrayBuffer {
    const padding = "=".repeat((4 - (base64url.length % 4)) % 4)
    const base64 = (base64url + padding).replace(/-/g, "+").replace(/_/g, "/")

    const binary = atob(base64)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
    }
    return bytes.buffer
}

/**
 *
 *
 */
export function parseCreationOptions(jsonOptions: any): PublicKeyCredentialCreationOptions {
    const options = jsonOptions.publicKey ? { ...jsonOptions.publicKey } : { ...jsonOptions }

    if (options.challenge) {
        options.challenge = base64URLToBuffer(options.challenge)
    }
    if (options.user?.id) {
        options.user = {
            ...options.user,
            id: base64URLToBuffer(options.user.id),
        }
    }
    if (options.excludeCredentials) {
        options.excludeCredentials = options.excludeCredentials.map((cred: any) => ({
            ...cred,
            id: base64URLToBuffer(cred.id),
        }))
    }

    /*                                 */
    if (!options.pubKeyCredParams || options.pubKeyCredParams.length === 0) {
        /*                                     */
        options.pubKeyCredParams = [
            { type: "public-key", alg: -7 },
            { type: "public-key", alg: -257 },
        ]
    }

    /*                                                                     */
    if (options.rp?.id === "localhost") {
        delete options.rp.id
    }

    if (!options.authenticatorSelection) {
        options.authenticatorSelection = {
            residentKey: "preferred",
            userVerification: "preferred",
            requireResidentKey: false,
        }
    }

    if (!options.timeout) {
        options.timeout = 60000
    }

    if (!options.attestation) {
        options.attestation = "none"
    }

    return options
}

/**
 *
 *
 */
export function parseRequestOptions(jsonOptions: any): PublicKeyCredentialRequestOptions {
    const options = jsonOptions.publicKey ? { ...jsonOptions.publicKey } : { ...jsonOptions }

    if (options.challenge) {
        options.challenge = base64URLToBuffer(options.challenge)
    }
    if (options.allowCredentials) {
        options.allowCredentials = options.allowCredentials.map((cred: any) => ({
            ...cred,
            id: base64URLToBuffer(cred.id),
        }))
    }

    return options
}

/**
 *
 *
 */
export function serializeCredential(credential: PublicKeyCredential): any {
    const response = credential.response as AuthenticatorAttestationResponse | AuthenticatorAssertionResponse
    const clientExtensionResults = credential.getClientExtensionResults()

    const res: any = {
        id: credential.id,
        rawId: bufferToBase64URL(credential.rawId),
        response: {
            clientDataJSON: bufferToBase64URL(response.clientDataJSON),
        },
        type: credential.type,
        clientExtensionResults,
        authenticatorAttachment: credential.authenticatorAttachment,
    }

    if ("attestationObject" in response) {
        /*           */
        res.response.attestationObject = bufferToBase64URL(response.attestationObject)
    }

    if ("authenticatorData" in response) {
        /*    */
        res.response.authenticatorData = bufferToBase64URL(response.authenticatorData)
    }

    if ("signature" in response) {
        /*    */
        res.response.signature = bufferToBase64URL(response.signature)
    }

    if ("userHandle" in response && response.userHandle) {
        /*    */
        res.response.userHandle = bufferToBase64URL(response.userHandle)
    }

    return res
}

export async function fetchJSON(url: string, method: string, data: object, abortSignal?: AbortSignal) {
    const response = await fetch(url, {
        method: method,
        headers: {
            "Content-Type": "application/json",
        },
        signal: abortSignal,
        body: JSON.stringify(data),
    })
    return response.json()
}

export async function fetchJSONWithHeaders(url: string, method: string, data: object, abortSignal?: AbortSignal) {
    const response = await fetch(url, {
        method: method,
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "manual",
        signal: abortSignal,
        body: JSON.stringify(data),
    })
    return { status: response.status, headers: response.headers }
}
